module UserAssignments
{
	export enum LinkTypes
	{
		Certified = 0,
		Assigned = 1,
		Supervising = 2,
	}

	interface IUpdateAssignmentRequest
	{
		DepartmentID : string;
		UserID : string;
	  LinkType: LinkTypes;
	  Value : boolean;
	}

	export function UpdateAssignment(userID: string, departmentID: string, linkType: LinkTypes, value: boolean, callback: () => any)
	{
		var data: IUpdateAssignmentRequest = {
			DepartmentID: departmentID,
			UserID : userID,
			LinkType: linkType,
			Value : value
		};
		$.ajax(
			"/Api/Users/UpdateAssignment",
			{
				data: JSON.stringify(data),
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				type: "POST",
				timeout: 5000,
				success: callback,
				error: notifyFailure
			}
		);
	}

	function notifyFailure()
	{
		Notifications.Warning("Update user assignment failed.");
	}
}